import moment from 'moment-timezone'

export const displayFieldsRows = 3;

export function getPeriodDisplayFields(schedulePeriod, isTeacherSelected = false, isLocationSelected = false, isCourseSelected = false) {
  let fields = [
    { field: 'title', value: `${schedulePeriod.periodNumber} ${schedulePeriod.displayName}` }, 
  ];

  if (!isTeacherSelected) {
    fields.push({ field: 'teacherName', value: schedulePeriod.teacherName || 'N/A' });
  }

  if (!isLocationSelected) {
    fields.push({ field: 'locationName', value: schedulePeriod.locationName || 'N/A' });
  }

  if (!isCourseSelected) {
    fields.push({ field: 'courseDescription', value: schedulePeriod.courseDescription ?? 'N/A' });
  }

  return fields;
}

export function getPeriodToolTipFields(schedulePeriod) {
  const mPeriodStart = schedulePeriod.uStart ? moment.unix(schedulePeriod.uStart) : null;
  const mPeriodEnd = schedulePeriod.uEnd ? moment.unix(schedulePeriod.uEnd) : null;

  const title = (mPeriodStart && mPeriodEnd && schedulePeriod.minuteLength)
    ? `${mPeriodStart.format('h:mma')}-${mPeriodEnd.format('h:mma')} (${schedulePeriod.minuteLength} mins)`
    : '';

  return [
    { field: 'title', label: '', value: title },
    { field: 'periodNumber', label: 'period number', value: schedulePeriod.periodNumber },
    { field: 'displayName', label: 'display name', value: schedulePeriod.displayName },
    { field: 'courseDescription', label: 'course description', value: schedulePeriod.courseDescription ?? 'N/A' },
    { field: 'locationName', label: 'location name', value: schedulePeriod.locationName },
  ];
}